/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HeatingEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const HeatingEnum = {
    NUMBER_1: 1 as HeatingEnum,
    NUMBER_2: 2 as HeatingEnum,
    NUMBER_3: 3 as HeatingEnum,
    NUMBER_4: 4 as HeatingEnum,
    NUMBER_5: 5 as HeatingEnum,
    NUMBER_6: 6 as HeatingEnum,
    NUMBER_7: 7 as HeatingEnum,
    NUMBER_8: 8 as HeatingEnum
};

